import { concat } from 'lodash';

import { SCOPES } from 'constants/roles';

import StuffToEatFoodProduct from './navigation-stuff-to-eat-food-product';
import StuffToEatDish from './navigation-stuff-to-eat-dish';
import StuffToEatDrink from './navigation-stuff-to-eat-drink';
import StuffToEatMeal from './navigation-stuff-to-eat-meal';

export default {
  label: 'label.stuff_to_eat',
  name: '',
  type: 'section',
  url: '/professional/stuff-to-eat',
  navigationIcon: 'far fa-utensils-alt',
  scope: SCOPES.CREATOR,
  pages: concat(
    StuffToEatFoodProduct,
    StuffToEatDish,
    StuffToEatDrink,
    StuffToEatMeal,
  ),
};



// WEBPACK FOOTER //
// ./src/data/navigations/stuff-to-eat/index.js